// extracted by mini-css-extract-plugin
export default {"docTypeFormControl":"YJ6lyygG","styledSelectField":"H0GRF8ol","Mui-focused":"zV_yg26v","item":"PuLdZ1ej"};